import React from 'react';
import NikeTvDateDialog from '@/nike-tv/views/dialogs/NikeTvDateDialog';
import NikeTvArchiveSearchFilterDialog from '@/nike-tv/views/dialogs/archive/NikeTvArchiveSearchFilterDialog';
import { NikeTvNikeoneSearchFilterDialog } from '@/nike-tv/views/dialogs/nikeone/NikeTvNikeoneSearchFilterDialog';

export const nikeTvDialogs = {
    'nikeTv/date-filter': popup => {
        const props = popup.get('data') as React.ComponentProps<typeof NikeTvDateDialog>;
        return <NikeTvDateDialog {...props} />;
    },
    'nikeTvArchive/search-filter': popup => {
        const props = popup.get('data') as React.ComponentProps<typeof NikeTvArchiveSearchFilterDialog>;
        return <NikeTvArchiveSearchFilterDialog {...props} />;
    },
    'nikeTvNikeone/search-filter': popup => {
        const props = popup.get('data') as React.ComponentProps<typeof NikeTvNikeoneSearchFilterDialog>;
        return <NikeTvNikeoneSearchFilterDialog {...props} />;
    }
};
